export const Spinner = (props: {}) => (
  <div className={"spinner-container"}>
    <div className="spinner">
      <div className="dot1"></div>
      <div className="dot2"></div>
    </div>
  </div>
);
